import { render } from "./flex-container.vue?vue&type=template&id=32f6ae16"
import script from "./flex-container.vue?vue&type=script&lang=js"
export * from "./flex-container.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__